import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { DisplayIconFactory } from './display-icon-factory.interface';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class LightFactory implements DisplayIconFactory {
    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        const icon = {
            ...this.createPartialIcon(() => !!item.actualValue),
            getLabelText: () => item.displayValue || item.name,
            isLabelVisible: () => true,
            getValue: () => item.value,
            materialIcon: !!item.actualValue ? 'lightbulb' : 'lightbulb_outline',
        };

        return icon;
    }

    public createDisplayIconForBehavior(getIsOn: () => boolean): IDisplayInfoIcon {
        const icon: IDisplayInfoIcon = {
            ...this.createPartialIcon(getIsOn),
            getLabelText: () => '',
            isLabelVisible: () => false,
            getValue: () => getIsOn() ? 'true' : 'false',
        };

        return icon;
    }

    private createPartialIcon(getIsOn: () => boolean): Partial<IDisplayInfoIcon> {

        const icon: Partial<IDisplayInfoIcon> = {
            materialIcon: getIsOn() ? 'lightbulb' : 'lightbulb_outline',
        };

        return icon;
    }
}
